import React from 'react'
import moment from 'moment'
import { Row, Col } from 'antd'
import { Text } from 'src/components/Ant'
import { R12Header } from 'src/store/ducks/reports/types'
import * as Css from './styles'

interface SectionHeaderProps
  extends Readonly<{
    data: R12Header[]
  }> {}

function SectionHeader({ data }: SectionHeaderProps) {
  const { end_date, participant_name, service, start_date } = data?.[0] || {}

  const startDate = `${
    moment(moment.unix(start_date).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`
  const endDate = `${
    moment(moment.unix(end_date).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`

  return (
    <Css.SectionHeader>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.12.header.service">
            <span id="value">{service}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.12.header.start_date">
            <span id="value">{startDate}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.12.header.participant_name">
            <span id="value">{participant_name || ' - '}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.12.header.end_date">
            <span id="value">{endDate}</span>
          </Text>
        </Col>
      </Row>
    </Css.SectionHeader>
  )
}

export default SectionHeader
